import { render, staticRenderFns } from "./AscDataSheetWrapper.vue?vue&type=template&id=0ec7a908&"
import script from "./AscDataSheetWrapper.vue?vue&type=script&lang=js&"
export * from "./AscDataSheetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscDataSheetWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports